import { useState, useRef } from 'react'
import { Box, Button, Grid2, Typography, } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { TextFormField } from '../../shared/components/FormFields/TextFormField'
import useContactStore from '../../shared/store/contactStore'
import { useMutation, useQueryClient } from '@tanstack/react-query';
import ContactPersonDetail from './ContactPersonDetail';
import { useToaster } from '../../shared/utils/ToasterProvider';
import ReCAPTCHA from 'react-google-recaptcha';
import { CaptchaKey, Constants } from '../../shared/constants';
import Heading from '../../shared/utils/Heading';
import { LocationSelectorField } from '../../shared/components/LocationSelectorField';
import useResponsive from '../../shared/utils/Responsive';
import api from '../../assets/nodeApi/axiosInstance';



const Apartment = () => {
    const queryClient = useQueryClient();
    const [errorText, setErrorText] = useState("")
    const recaptchaRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(null);
    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
        setErrorText("")
    };
    const { showToaster } = useToaster();
    const { contactPersons, resetContactPersons } = useContactStore();


    const designationOption = [
        { id: 1, label: "Apartment Owner", value: "Apartment Owner" },
        { id: 2, label: "Tenant/Renter", value: "Tenant/Renter" },
        { id: 3, label: "Association President", value: "Association President" },
        { id: 4, label: "Secretary", value: "Secretary" },
        { id: 5, label: "Treasurer", value: "Treasurer" },
        { id: 6, label: "Committee Members", value: "Committee Members" },
        { id: 7, label: "Property Manager", value: "Property Manager" },
        { id: 8, label: "Parent counselor", value: "Parent counselor" }
        
    ];

    const validationSchema = yup.object().shape({
        apartment_name: yup.string().required("Apartment Name is required"),
        no_of_flats: yup
            .number()
            .required("Number of Flats is required")
            .max(5000, "Maximum 5000 flats allowed"),

        address: yup.string().required("Address is required"),
        city_id: yup.string().required("City is required"),
        state_id: yup.string().required("State is required"),
        country_id: yup.string().required("Country is required"),
        zone_id: yup.string().required("Zone is required"),
        pincode: yup
            .string()
            .required("Pincode is required")
            .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
        latitude: yup.number().required("Latitude is required"),
        longitude: yup.number().required("Longitude is required")

    });
    const initialValues = {
        apartment_name: "",
        no_of_flats: "",
        address: "",
        street: "",
        landmark: "",
        city_id: "",
        state_id: "",
        country_id: "",
        pincode: "",
        latitude: "",
        longitude: "",
        zone_id: ""
    };

    const mutation = useMutation({
        mutationFn: (formData) => api.post("collab-apartment-on-boarding/create", formData),
    });



    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        if (!contactPersons || contactPersons.length === 0) {
            return showToaster('Warning!', 'Add at least one contact person', 'warning')
        }
        if (!captchaValue) {
            setErrorText("Please complete the CAPTCHA!")
            return;
        }


        const ojb = {
            ...values,
            contact_person_details: contactPersons.map(({ id, ...rest }) => rest)
        };
        mutation.mutate(ojb, {
            onSuccess: (response) => {
                if (response?.data) {
                    showToaster('Apartment Onboarding Done Successfully!', 'Thank you for onboarding! We’ve received your details and will be in touch soon.', 'success')
                } else {
                    showToaster('Warning', 'Message sent, but no response from server.', 'warning');
                }
                queryClient.invalidateQueries({ queryKey: ["apartment_list"] });
                queryClient.invalidateQueries({ queryKey: ["course_apartment_list"] });
                queryClient.invalidateQueries({ queryKey: ["collab-apartment-name-list"] });
                queryClient.invalidateQueries({ queryKey: ["unassigned-apartments"] });
                resetForm();
                resetContactPersons()
                recaptchaRef.current?.reset();
                setCaptchaValue(null);
            },
            onError: (error) => {
                showToaster('Error', 'Error Occurred"', 'error')

            },
            onSettled: () => {
                setSubmitting(false);
            }
        });
    };
    const isMediumScreen = useResponsive("md")
    return (
        <>

            {/* <Box
                sx={{
                    position: "relative",
                    backgroundImage: `url(${Constants.customImages.ApartmentConnect})`,
                    backgroundSize: "100% auto",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    overflow: "hidden",
                    minHeight: { xs: "180px", sm: "300px", md: "80vh" },
                }}
            /> */}

            <Box
                sx={{
                    position: "relative",
                    backgroundImage: `url(${isMediumScreen ? Constants.customImages.ApartmentConnectWithContent : Constants.customImages.ApartmentConnect})`,
                    backgroundSize: "100% auto",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    overflow: "hidden",
                    minHeight: { xs: "auto", sm: "auto", md: "60vh" },
                    aspectRatio: { xs: "16/8", sm: "16/9", md: "auto" },
                }}
            >
                {
                    !isMediumScreen && <>
                        <Grid2 container height={"30%"}>
                            <Grid2 children size={4} />
                            <Grid2 children size={4} display={"flex"}
                                sx={{
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                <Box component={"img"} src={Constants.customImages.NurturingMind} width={"7rem"}
                                    sx={{
                                        transform: "translateY(50px)",
                                    }}
                                />
                                <Box
                                    sx={{
                                        transform: "translateY(0px)",
                                    }}
                                >
                                    <Typography variant='body2' color='#DC143C'>Nurturing Young Minds</Typography>
                                    <Typography variant='body2'>Cultivate a love for learning and exploration, setting them up for future success</Typography>
                                </Box>
                            </Grid2>


                        </Grid2>
                        <Grid2 container height={"40%"}>
                            <Grid2 children size={1} />
                            <Grid2 children size={3.5}
                                display={"flex"}

                                sx={{
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                <Box component={"img"} src={Constants.customImages.NoCommutHassle} width={"7rem"}
                                    sx={{
                                        transform: "translateY(-70px)",
                                    }}
                                />
                                <Box
                                    sx={{
                                        transform: "translateY(-10px)",
                                    }}
                                >
                                    <Typography variant='body2' color='#59C7D2'>No Commute Hassle</Typography>
                                    <Typography variant='body2'>Save time and resources, focus on what matters most</Typography>
                                </Box>
                            </Grid2>
                            <Grid2 children size={4.2} />

                            <Grid2 children size={3.3}
                                display={"flex"}

                                sx={{
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                <Box component={"img"} src={Constants.customImages.EmpoweringParent} width={"7rem"}
                                    sx={{
                                        transform: "translateY(-20px)",
                                    }}
                                />
                                <Box
                                    sx={{
                                        transform: "translateY(40px)",
                                    }}
                                >
                                    <Typography variant='body2' color='#87CEEB'>Empowering Parents</Typography>
                                    <Typography variant='body2'>Provide the best opportunities for your kids, without worrying about travel</Typography>
                                </Box>


                            </Grid2>

                        </Grid2>

                        <Grid2 container height={"30%"}>


                            <Grid2 size={4.5}
                                display={"flex"}

                                sx={{
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                <Box component={"img"} src={Constants.customImages.SafeConvenient} width={"7rem"}
                                    sx={{
                                        transform: "translateY(-30px)",
                                    }}
                                />
                                <Box>
                                    <Typography variant='body2' color="#FAC584">Safe & Convenient</Typography>
                                    <Typography variant='body2'>
                                        Kids learn from highly skilled trainers from the comfort of home
                                    </Typography>
                                </Box>
                            </Grid2>

                            <Grid2 size={1.7} />



                            <Grid2
                                size={4.5}
                                display={"flex"}

                                sx={{
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                <Box component={"img"} src={Constants.customImages.BuildingFriendship} width={"7rem"}
                                    sx={{
                                        transform: "translateY(-80px)",
                                    }}
                                />
                                <Box
                                    sx={{
                                        transform: "translateY(-10px)", // move it upward
                                    }}>

                                    <Typography variant='body2' color='#B235E6'>Building Friendships</Typography>
                                    <Typography variant='body2'>
                                        Kids make new connections, promoting harmony amongst residents
                                    </Typography>
                                </Box>
                            </Grid2>


                            <Grid2 size={0.5} />
                        </Grid2>


                    </>
                }



            </Box>
            <CustomDivider orientation='horizontal' />

            <CustomDivider orientation='horizontal' />
            <Heading
                Heading="Get settled in smoothly with our step-by-step  On Boarding guide"
                SubHeading="Welcome to Your New Home! "
            />
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {({ setFieldValue, setFieldError, values }) => (
                    <Form>

                        <Grid2 container spacing={5}>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="apartment_name"
                                    component={TextFormField}
                                    label="Apartment Name"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="no_of_flats"
                                    component={TextFormField}
                                    label="Number Of Flats"
                                    isRequired={true}
                                    type={"number"}
                                />
                            </Grid2>
                            <Grid2 children size={12}>
                                <Field
                                    name="address"
                                    component={TextFormField}
                                    label="Address"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="street"
                                    component={TextFormField}
                                    label="Street"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="landmark"
                                    component={TextFormField}
                                    label="Landmark"
                                    isRequired={true}
                                />
                            </Grid2>
                            <LocationSelectorField
                                countryField="country_id"
                                stateField="state_id"
                                cityField="city_id"
                                isStoredId={true}
                                zipField="pincode"
                                zoneField="zone_id"
                                Input_Width={{ xs: 12, sm: 6 }}
                                isZone={true}
                            />
                            {/* <Grid2 size={12}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Select Apartment Location
                                </Typography>
                                <MapPicker />
                            </Grid2> */}

                            <Grid2 size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="latitude"
                                    component={TextFormField}
                                    label="Latitude"
                                    isRequired={true}
                                    type="number"
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="longitude"
                                    component={TextFormField}
                                    label="Longitude"
                                    isRequired={true}
                                    type="number"
                                />
                            </Grid2>

                        </Grid2>
                        <CustomDivider />
                        <ContactPersonDetail designationOption={designationOption} />
                        <Grid2 container my={5} >
                            <Grid2 children size={{ xs: 12, sm: 9 }} >
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={CaptchaKey}
                                    onChange={handleCaptchaChange}
                                />
                                <CustomDivider size={"2rem"} />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 3 }}>
                                <Button variant='contained' fullWidth type='submit'>Submit</Button>
                            </Grid2>
                            <Grid2 size={12}>
                                {errorText && <Typography variant="body2" fontSize={"10px"} color="#DC143C">{errorText}</Typography>}
                            </Grid2>
                        </Grid2>
                    </Form>
                )}
            </Formik>

        </>
    )
}

export default Apartment